/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 1159
// module chunks = 0